// NOTE: i18next 17.0.0 ships with a broken `index.js` (it does
// `require('./dist/cjs/i18next.js').default` but the cjs bundle exports the
// instance directly via `module.exports = i18next` — no `.default`). We must
// therefore import the cjs bundle directly to get a valid instance.
import i18n from 'i18next/dist/cjs/i18next.js'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'fr',
		debug: false,

		// Strip region codes ('fr-FR' -> 'fr'). Without this the language
		// detector may pick 'fr-FR', i18next then tries to load
		// /locales/fr-FR/<ns>.json (404) and `hasLoadedNamespace` from
		// react-i18next never returns true cleanly for the bundles that
		// were actually loaded under 'fr' / 'en'.
		load: 'languageOnly',

		react: {
			// Use the existing top-level <Suspense fallback={<TotalLoader/>}>
			// in src/index.js to wait for namespaces to be ready before
			// rendering. Without this, components render once with raw
			// keys, and on a page refresh the cached HTTP response for
			// the JSON namespace can arrive *before* react-i18next's
			// useEffect attaches its `languageChanged loaded` listener
			// — so the listener never fires and the UI stays stuck on
			// the keys. With useSuspense:true there is no such race:
			// the component simply waits for the namespace.
			useSuspense: true,
			// Still useful as a safety net for components that ignore
			// suspense or re-render after language change.
			bindI18n: 'languageChanged loaded',
			bindI18nStore: 'added',
			// `fallback` makes `useTranslation(['user', 'documentation'])`
			// search every listed namespace for a key. Without this,
			// react-i18next 10 fixes `t` to the FIRST namespace only,
			// so `t('oversight')` in TotalToolBar would silently miss
			// keys present in secondary namespaces.
			nsMode: 'fallback',
		},

		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	})

export default i18n

